import { type RecentlyVisitedType, useRecentlyVisitedStore } from "@/stores";

const getMetaContent = (selector: string) => {
  return document.querySelector<HTMLMetaElement>(selector)?.content || "";
};

const getRecentlyVisitedType = (path: string): RecentlyVisitedType => {
  if (path.startsWith("/online-degree-programs/")) {
    return "degree";
  }

  if (path.startsWith("/newsroom/")) {
    return "news";
  }

  return "page";
};

const getSlug = (path: string) => {
  return path.replace(/^\/|\/$/g, "") || "home";
};

const shouldTrackRoute = (path: string) => {
  if (path.startsWith("/degree-program-request-info-thank-you")) {
    return false;
  }

  return true;
};

export default defineNuxtPlugin((nuxtApp) => {
  const recentlyVisitedStore = useRecentlyVisitedStore();
  const router = useRouter();

  const trackCurrentRoute = async () => {
    const route = router.currentRoute.value;

    if (!shouldTrackRoute(route.path)) {
      return;
    }

    await nextTick();

    window.setTimeout(() => {
      const title =
        getMetaContent('meta[name="Title"]') ||
        document.title.replace(/\s*\|\s*ASU Online\s*$/i, "");

      if (!title) {
        return;
      }

      recentlyVisitedStore.addVisit({
        slug: getSlug(route.path),
        url: route.fullPath,
        title,
        metaDescription:
          getMetaContent('meta[name="Description"]') ||
          getMetaContent('meta[name="description"]') ||
          undefined,
        image:
          getMetaContent('meta[property="og:image"]') ||
          getMetaContent('meta[name="twitter:image"]') ||
          undefined,
        type: getRecentlyVisitedType(route.path)
      });
    }, 0);
  };

  nuxtApp.hook("app:mounted", trackCurrentRoute);
  router.afterEach(() => {
    trackCurrentRoute();
  });
});
